import { Icons } from "@app/shared";
import { FC } from "react";
import { MediaNotice, noticeSeverityClass, visibleNotices } from "./mediaNoticeHelpers";

/** Severity → SVG icon (no emoji: they render inconsistently and read as clutter in a dense table). */
export const NoticeSeverityIcon: FC<{ severity: string | undefined; className?: string }> = ({ severity, className }) => {
    const Icon = severity === "Error" ? Icons.CircleError : severity === "Info" ? Icons.Info : Icons.AlertTriangle;
    return <Icon className={`${noticeSeverityClass(severity)} ${className ?? ""}`} aria-hidden />;
};

/**
 * Vertical list of a request's quality notices, each as an icon + its sentence (severity-colored).
 * Used for the clip-viewer banner and the dashboard "Result" column — the text is ALWAYS visible
 * (never hover-only), so it works on touch / small screens. Restricted (super-admin-only) notices
 * are hidden unless `isSuperAdmin`; the public clip viewer leaves it false (and the server already
 * strips them anyway). Returns null when there's nothing to show.
 */
export const MediaNoticeList: FC<{ notices: string | null | undefined; className?: string; isSuperAdmin?: boolean; exclude?: (n: MediaNotice) => boolean }> = ({ notices, className, isSuperAdmin = false, exclude }) => {
    const list = visibleNotices(notices, isSuperAdmin).filter((n) => !exclude?.(n));
    if (!list.length) return null;
    return (
        <ul className={`flex flex-col gap-1 ${className ?? ""}`}>
            {list.map((n: MediaNotice) => (
                <li key={n.kind} className={`flex items-start gap-1.5 text-sm ${noticeSeverityClass(n.severity as string)}`}>
                    <NoticeSeverityIcon severity={n.severity as string} className="mt-0.5 h-3.5 w-3.5 shrink-0" />
                    <span>{n.text ?? n.kind}</span>
                </li>
            ))}
        </ul>
    );
};
